import React from 'react';
export function AssociationsSection() {
  const associations = [{
    name: 'Michigan Manufacturers Association',
    href: 'https://mimfg.org/',
    logoSrc: 'https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Michigan%20Manufacturers%20Association.png'
  }, {
    name: 'SME',
    href: 'https://www.sme.org/',
    logoSrc: 'https://cdn.magicpatterns.com/uploads/2aLQuEVq5BgrSiBzgnsu7m/SME.jpg'
  }, {
    name: 'American Mold Builders Association',
    href: 'https://amba.org/',
    logoSrc: 'https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/American%20Mold%20Builders%20Association.png800x800.png'
  }];
  return <section className="py-12 md:py-16 bg-gray-50 border-y border-gray-200" data-id="element-2531">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2532">
        <h2 className="text-2xl md:text-3xl font-bold text-navy text-center mb-10" data-id="element-2533">
          Proud Members of Leading Manufacturing Associations
        </h2>
        <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12" data-id="element-2534">
          {associations.map((association, index) => <a key={index} href={association.href} target="_blank" rel="noopener noreferrer" className="group" aria-label={association.name} data-id="element-2535">
              <div className="w-72 h-44 bg-white rounded-lg shadow-sm group-hover:shadow-md transition-shadow flex items-center justify-center border border-gray-200 p-6" data-id="element-2536">
                <img src={association.logoSrc} alt={`${association.name} logo`} className="block max-h-full max-w-full w-auto h-auto object-contain" data-id="element-2537" />
              </div>
            </a>)}
        </div>
      </div>
    </section>;
}